"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rxStatuses = void 0;
var rxStatuses;
(function (rxStatuses) {
    /**
     * The prescription is pending creation within the vendor system.
     */
    rxStatuses["PENDING"] = "pending";
    /**
     * The prescription is open within the vendor system.
     */
    rxStatuses["OPEN"] = "open";
    /**
     * The prescription has been closed within the vendor system.
     */
    rxStatuses["CLOSED"] = "closed";
    /**
     * The prescription has expired within our system.
     */
    rxStatuses["EXPIRED"] = "expired";
    /**
     * The prescription has been closed due to end-of-service.
     */
    rxStatuses["END_OF_SERVICE"] = "endOfService";
})(rxStatuses || (exports.rxStatuses = rxStatuses = {}));
